import { useMemo } from 'react';

import { expVal } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import {
	AccessStatus,
	ConfluenceEdition,
} from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

export type CwrSplitButtonCohort = 'control' | 'variant_1' | 'variant_2' | 'not-enrolled';

export function useCwrSplitButtonExperiment() {
	const { accessStatus, edition, isLoggedIn } = useSessionData();
	const isAnonymousUser = accessStatus === AccessStatus.ANONYMOUS_ACCESS || !isLoggedIn;
	const isStandardUser = edition === ConfluenceEdition.STANDARD;

	const cohort: CwrSplitButtonCohort =
		isStandardUser && !isAnonymousUser
			? (expVal(
					'navx_universal_create_cwr_split_button',
					'cohort',
					'control',
				) as CwrSplitButtonCohort)
			: 'not-enrolled';

	const isEnabled = cohort === 'variant_1' || cohort === 'variant_2';

	return useMemo(() => ({ cohort, isEnabled }), [cohort, isEnabled]);
}
